import { getTreatment } from "@/generated/api/sdk.gen"
import type { Api } from "@/platform/api/api"
import { PSEUDO_ID_HEADER_LEGACY } from "@/platform/api/constants"
import { body } from "@/platform/api/gateways/common"

interface TreatmentContext {
  pseudoId?: string
  attributes?: Record<string, unknown>
}

export const experimentsGateway = (api: Api) => ({
  treatment: (experiment: string, { pseudoId, attributes }: TreatmentContext = {}) =>
    body(getTreatment({ ...api.request({ credentials: "public", ...(pseudoId ? { headers: { [PSEUDO_ID_HEADER_LEGACY]: pseudoId } } : {}) }), body: { experiment, attributes } })),
})

export type ExperimentsGateway = ReturnType<typeof experimentsGateway>
